export enum PresenceAnswer {
  Undefined = 0,
  Present = 1,
  Absent = 2,
  Undecided = 3,
}
